/* eslint-disable import/first */
import './public-path'; // Don't try to re-order this, it needs to be imported before any other modules

import React from 'react';
import ReactDOM from 'react-dom';
import { initializeIcons } from '@fluentui/react';

import './index.less';

initializeIcons();

const App = require('./app').default;

ReactDOM.render(<App />, document.getElementById('root'));
